var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('router-link',{staticClass:"btn btn-sm btn-secondary wd-xs",attrs:{"to":{name: _vm.url},"type":"submit"}},[_c('span',[_vm._v(_vm._s(_vm.$t('button.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success wd-xs",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('button.save')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546035c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons.vue
// module id = null
// module chunks = 